import { connect } from "react-redux"
import { Dispatch } from "redux"
import {
  notificationAdd,
  notificationInit,
} from "../../actions/pages/notificationActionCreator"
import { updateCount } from "../../actions/unreadNotificationCount"
import { RootState, ReduxAction } from "../../reducers"
import { IRootPagesState } from "../../reducers/pages"
import { Notification } from "../../rpcs/dist/UserRPC"

export interface IContainerProps {
  notification: IRootPagesState["notification"]
  actions: ActionDispatcher
}

export class ActionDispatcher {
  constructor(private dispatch: (action: ReduxAction) => void) {}

  public init(notifications: Notification[]) {
    this.dispatch(
      notificationInit({
        notifications,
      }),
    )
  }

  public add(notifications: Notification[]) {
    this.dispatch(
      notificationAdd({
        notifications,
      }),
    )
  }

  public updateNotificationCount(unreadNotificationCount: number) {
    this.dispatch(updateCount(unreadNotificationCount))
  }
}

const mapDispatchToProps = (dispatch: Dispatch<ReduxAction>) => ({
  actions: new ActionDispatcher(dispatch),
})

const mapStateToProps = ({ pages }: RootState) => ({
  notification: pages.notification,
})

export const container = connect(mapStateToProps, mapDispatchToProps)
